"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionProps = exports.RATING_AND_REVIEW_DIALOG = void 0;
const RATING_AND_REVIEW_DIALOG = exports.RATING_AND_REVIEW_DIALOG = 'rating-and-review-dialog';
const transitionProps = exports.transitionProps = {
  timeout: 0
};
